<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { Brand } from '@xcel-next/core/enums'

import { usePageStore } from '../../stores/page'
// these components will be injected into the app via slots
import PageWrapper from '../../components/PageWrapper.vue'
import HeaderUserNavi from '../../components/shared/HeaderUserNavi.vue'
import { useDefaultAppInit, defaultAppInitProps } from '../../composables/use-default-app-init'
import PageFooter from './theme/Footer.vue'
import HeaderLogo from './theme/HeaderLogo.vue'
import StarsignSlider from './theme/StarsignSlider.vue'

import type { DefaultAppInitProps } from '../../composables/use-default-app-init'

const props = withDefaults(defineProps<Partial<DefaultAppInitProps>>(), {
  brand: Brand.astrowoche,
  url: defaultAppInitProps.url.default,
  authorization: defaultAppInitProps.authorization.default,
  consentConfig: null,
  adSizePrediction: null,
  adDefendScript: defaultAppInitProps.adDefendScript.default,
  crawlerDetected: defaultAppInitProps.crawlerDetected.default,
  config: defaultAppInitProps.config.default
})

useDefaultAppInit(props)

const { pageData, brandFromStore } = storeToRefs(usePageStore())

const sliderOptions = { lazyLoad: 12 }
</script>

<template>
  <PageWrapper :page-data="pageData ?? undefined"
               :brand="brandFromStore">
    <template #header-logo>
      <HeaderLogo />
    </template>
    <template #header-user-navi>
      <HeaderUserNavi />
    </template>
    <template #content-top>
      <StarsignSlider :slider-options="sliderOptions" />
    </template>
    <template #footer>
      <PageFooter :brand="brandFromStore"
                  :footer-data="pageData?.footer" />
    </template>
  </PageWrapper>
</template>
